@if (logo) {
	<div class="logo">
		<img [src]="logo" alt="Survey Logo">
	</div>
}

<language-selector></language-selector>
